export default function getParameterByName({ selector = '' }) {
  if (typeof window !== 'undefined') {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    return urlParams.get(selector)
  }
}
